import { render, staticRenderFns } from "./modals.vue?vue&type=template&id=0c6c70fc&"
import script from "./modals.vue?vue&type=script&lang=js&"
export * from "./modals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports